import { autoUpdate, offset, shift, useClick, useDismiss, useFloating, useFocus, useInteractions } from '@floating-ui/react';
import { useIsomorphicLayoutEffect } from '@react-hookz/web';
export const useWidgetOverlay = ({
  open,
  type,
  options,
  layout,
  onOpenChange
}) => {
  const getPositionOfBoundaryElementId = {
    name: 'getPositionOfBoundaryElementId',
    fn: () =>
    // @ts-expect-error TS(2531): Object is possibly 'null'.
    document?.getElementById(options?.shiftBoundaryElementId)?.getClientRects()[0]
  };
  const middlewares = {
    full: [offset(6), shift({
      // https://floating-ui.com/docs/detectoverflow#boundary
      // @ts-expect-error TS(2322) FIXME: Type 'HTMLElement | null | undefined' is not assig... Remove this comment to see the full error message
      boundary: (options?.shiftBoundaryElementId && document.getElementById(options.shiftBoundaryElementId)) ?? undefined
    })],
    compact: [getPositionOfBoundaryElementId],
    sidebar: [getPositionOfBoundaryElementId]
  };
  const {
    x,
    y,
    strategy,
    context,
    isPositioned,
    refs
  } = useFloating({
    open,
    onOpenChange,
    middleware: middlewares[layout],
    placement: options?.placement,
    strategy: 'fixed',
    whileElementsMounted: autoUpdate
  });
  const {
    getReferenceProps,
    getFloatingProps
  } = useInteractions([useClick(context, {
    enabled: type === 'popover',
    toggle: true,
    keyboardHandlers: false
  }), useFocus(context, {
    enabled: type === 'popover'
  }), useDismiss(context, {
    enabled: type === 'popover'
  })]);
  // https://floating-ui.com/docs/react-dom#effects
  useIsomorphicLayoutEffect(() => {
    if (isPositioned) {
      // @ts-expect-error TS(2345) FIXME: Argument of type 'HTMLElement | null' is not assig... Remove this comment to see the full error message
      scrollWidgetIntoViewIfNeeded(refs.floating.current);
    }
    if (!open && options?.scrollToTopOnClose === true) {
      document.documentElement.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [isPositioned]);
  if (type === 'drawer') {
    return {
      getReferenceProps: props => ({
        ...props,
        readOnly: true,
        onFocus: () => onOpenChange(true)
      }),
      getWidgetProps: props => ({
        ...props,
        onClose: () => onOpenChange(false)
      })
    };
  }
  return {
    getReferenceProps: props => ({
      ref: refs.setReference,
      ...getReferenceProps(props)
    }),
    getWidgetProps: props => ({
      ref: refs.setFloating,
      style: {
        position: strategy,
        left: x ?? 0,
        top: (y ?? 0) - (layout === 'compact' ? 50 : 0),
        visibility: x == null ? 'hidden' : 'visible'
      },
      ...getFloatingProps(props)
    })
  };
};
const scrollWidgetIntoViewIfNeeded = widgetElement => {
  const topSpacing = 70; // @FIXME should be dynamic depending on the reference element
  const bottomSpacing = 100;
  const scrollPosition = window.scrollY;
  const widgetRect = widgetElement.getBoundingClientRect();
  if (widgetRect.top < 0 || widgetRect.bottom >= window.innerHeight - bottomSpacing) {
    const availableSpaceTop = widgetRect.top - topSpacing;
    const requiredScrollCorrection = widgetRect.bottom - (window.innerHeight - bottomSpacing);
    window.scrollTo({
      top: availableSpaceTop - requiredScrollCorrection >= 0 ? scrollPosition + requiredScrollCorrection : scrollPosition + availableSpaceTop,
      behavior: 'smooth'
    });
  }
};